import React from 'react';
import styles from './search-input.module.scss';
import { Input, InputProps } from '../input';
import { CalendarIcon, CloseIcon, SearchIcon } from '../../../../assets/icons';

export interface SearchInputProps extends Omit<InputProps, 'type' | 'icon' | 'onIconClick'> {
  onClear?: () => void;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = 'Search',
  value,
  onChange,
  onClear,
  className = '',
  ...props
}) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
    }
  };


  const clearIcon = value ? (
    <CloseIcon/>
  ) : null;

  return (
    <div className={`${styles.searchInputWrapper} ${className}`}>
      <div className={styles.searchIconLeft}>
        <SearchIcon/>
      </div>
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        icon={clearIcon}
        onIconClick={clearIcon ? handleClear : undefined}
        className={styles.searchInput}
        {...props}
      />
    </div>
  );
};